import React, { useState, useRef, useEffect } from "react";

import "../mainbody/mainbody.css";
import ChatBubble from "../chatbubble/chatbubble";

import chatbot_logo from "../assets/logo.svg";
import ic_menu from "../assets/ic_menu.svg";
import ic_close from "../assets/ic_close.svg";
import ic_send_btn from "../assets/ic_send.svg";



function MainBody({
  onMenuClick,
  currentChatId,
  onUpdateChatTitle,
  onUpdateMessages,
  currentChat,
  onNewChat
}) {
  const chatBodyRef = useRef(null);
  const scrollToBottomRef = useRef(null);

  const getCurrentTime = () => {
    return new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const [messages, setMessages] = useState([
    { text: "Say Hello", isSender: false, time: getCurrentTime() },
  ]);

  // Reset messages when starting new chat
  useEffect(() => {
    if (currentChatId) {
      setMessages(currentChat?.messages || [
        { text: "Say Hello", isSender: false, time: getCurrentTime() },
      ]);
    }
  }, [currentChatId, currentChat]);

  const [inputMessage, setInputMessage] = useState("");

  const handleSendMessage = () => {
    if (inputMessage.trim() !== "") {
      const messageToSend = inputMessage;
      setInputMessage("");

      if (!currentChatId) {
        // Create new chat and store its ID
        const newChatId = Date.now(); // Same ID generation as in handleNewChat
        onNewChat();

        // Wait briefly for the new chat to be created
        setTimeout(() => {
          const newMessage = {
            text: messageToSend,
            isSender: true,
            time: getCurrentTime(),
          };

          const updatedMessages = [
            { text: "Say Hello", isSender: false, time: getCurrentTime() },
            newMessage
          ];
          setMessages(updatedMessages);

          // Update chat title with the message
          onUpdateChatTitle(newChatId, messageToSend);
          onUpdateMessages(newChatId, updatedMessages);

          // Simulate chatbot response
          setTimeout(() => {
            const chatbotMessage = {
              text: generateChatbotResponse(messageToSend),
              isSender: false,
              time: getCurrentTime(),
            };
            const messagesWithResponse = [...updatedMessages, chatbotMessage];
            setMessages(messagesWithResponse);
            onUpdateMessages(newChatId, messagesWithResponse);
          }, 1000);
        }, 100);

        return;
      }

      const newMessage = {
        text: messageToSend,
        isSender: true,
        time: getCurrentTime(),
      };

      const updatedMessages = [...messages, newMessage];
      setMessages(updatedMessages);

      if (messages.length === 0) {
        onUpdateChatTitle(currentChatId, messageToSend);
      }

      onUpdateMessages(currentChatId, updatedMessages);

      // Simulate chatbot response
      setTimeout(() => {
        const chatbotMessage = {
          text: generateChatbotResponse(messageToSend),
          isSender: false,
          time: getCurrentTime(),
        };
        const messagesWithResponse = [...updatedMessages, chatbotMessage];
        setMessages(messagesWithResponse);
        onUpdateMessages(currentChatId, messagesWithResponse);
      }, 1000);
    }
  };

  const generateChatbotResponse = (userMessage) => {
    // Mock chatbot responses based on user input
    if (userMessage.toLowerCase().includes("hello")) {
      return "Hi there! How can I help you today?";
    } else if (userMessage.toLowerCase().includes("how are you")) {
      return "I'm just a bot, but I'm doing great! Thanks for asking.";
    } else if (userMessage.toLowerCase().includes("bye")) {
      return "Goodbye! Have a great day!";
    } else {
      return "I'm sorry, I didn't understand that. Could you please rephrase?";
    }
  };

  // Effect to autoscroll to the bottom
  useEffect(() => {
    if (scrollToBottomRef.current) {
      scrollToBottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div className="main">
      <div className="main-top">
        <img src={ic_menu} className="sidebar-menu" alt="" onClick={() => { onMenuClick() }} />
        <div className="title-main">
          <img src={chatbot_logo} className="logo-bg" alt="" />
          <h1>Chatbot</h1>
        </div>
        <a href="/#" title="">
          <img src={ic_close} alt="" />
        </a>
      </div>

      <div className="chat-body" ref={chatBodyRef}>
        {messages.map((msg, index) => (
          <ChatBubble
            key={index}
            message={msg.text}
            isSender={msg.isSender}
            time={msg.time}
          />
        ))}
        {/* Invisible div to scroll into view */}
        <div ref={scrollToBottomRef}></div>
      </div>
      <div className="main-bottom">
        <input
          type="text"
          placeholder="type your message here...."
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
        />
        <button className="btn_send" onClick={handleSendMessage}>
          <img src={ic_send_btn} alt="" />
        </button>
      </div>
    </div>
  );
}

export default MainBody;
